import { qsa } from "@fluorescent/dom";

// Takes an array of selectors and sets the `--delay-offset-multiplier` variable in the correct order
//
//  @param {node} element The section element
//  @param {items} array Array of animation item selectors
export default (node, itemSelectors, offsetStart = 0) => {
  let delayOffset = offsetStart;

  itemSelectors.forEach(selector => {
    const items = qsa(selector, node);

    items.forEach(item => {
      item.style.setProperty("--delay-offset-multiplier", delayOffset);
      delayOffset++;
    });
  });

  return delayOffset;
};
